import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import Dialog from "../../../waybee-ui/Dialog/Dialog";
import Heading from "../../../waybee-ui/Heading/Heading";
import Button from "../../../waybee-ui/Button";

const JustifyAbsenceDialog = ({
  open,
  onClose,
  onConfirm,
  onRemove,
  studentName,
  lessonLabel,
  reasons,
  currentReasonId
}) => {
  const { t } = useTranslation();
  const [selectedReasonId, setSelectedReasonId] = useState("");

  useEffect(() => {
    if (open) {
      setSelectedReasonId(currentReasonId || "");
    }
  }, [open, currentReasonId]);

  const selectedReason = reasons.find(
    reason => String(reason.idJustificativaFalta) === String(selectedReasonId)
  );
  const hasChanged = String(selectedReasonId) !== String(currentReasonId || "");

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth closeButton>
      <DialogTitle>
        <Heading level={2}>{t("frequency.justify.title")}</Heading>
      </DialogTitle>
      <DialogContent>
        {studentName ? <Heading level={4}>{studentName}</Heading> : null}
        {lessonLabel ? (
          <Typography variant="body2" color="textSecondary">
            {lessonLabel}
          </Typography>
        ) : null}
        {reasons.length ? (
          <FormControl fullWidth margin="normal">
            <InputLabel id="justify-absence-reason-label">
              {t("frequency.justify.reason")}
            </InputLabel>
            <Select
              labelId="justify-absence-reason-label"
              value={selectedReasonId}
              onChange={event => setSelectedReasonId(event.target.value)}
            >
              {reasons.map(reason => (
                <MenuItem
                  key={reason.idJustificativaFalta}
                  value={String(reason.idJustificativaFalta)}
                >
                  {reason.descricao}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : (
          <Typography variant="body2" color="textSecondary">
            {t("frequency.justify.noReasons")}
          </Typography>
        )}
        {selectedReason ? (
          <Typography variant="body2" color="textSecondary">
            {t(
              selectedReason.abona
                ? "frequency.justify.excusedHint"
                : "frequency.justify.notExcusedHint"
            )}
          </Typography>
        ) : null}
        <Typography variant="body2" color="textSecondary">
          {t("frequency.justify.pendingHint")}
        </Typography>
      </DialogContent>
      <DialogActions>
        {currentReasonId ? (
          <Button onClick={onRemove} color="default">
            {t("frequency.justify.remove")}
          </Button>
        ) : null}
        <Button onClick={onClose} color="default">
          {t("common.actions.cancel")}
        </Button>
        <Button
          onClick={() => onConfirm(selectedReason)}
          color="primary"
          variant="contained"
          disabled={!selectedReason || !hasChanged}
        >
          {t("common.actions.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

JustifyAbsenceDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  studentName: PropTypes.string,
  lessonLabel: PropTypes.string,
  reasons: PropTypes.arrayOf(
    PropTypes.shape({
      idJustificativaFalta: PropTypes.string,
      descricao: PropTypes.string,
      abona: PropTypes.bool
    })
  ),
  currentReasonId: PropTypes.string
};

JustifyAbsenceDialog.defaultProps = {
  studentName: "",
  lessonLabel: "",
  reasons: [],
  currentReasonId: ""
};

export default JustifyAbsenceDialog;
